import clsx from 'clsx'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type Ref, ImgHTMLAttributes } from 'react'
import { LexicalMentionNodeData } from './Editor/LexicalMentionNode'
import styles from './MentionUser.module.css'

export interface MentionUserProps extends HTMLMotionProps<'div'> {
	data: Pick<LexicalMentionNodeData, 'screenName'> & Partial<Pick<LexicalMentionNodeData, 'avatar'>>
	ref?: Ref<HTMLDivElement>
}

// 处理用户头像的子组件
function UserAvatar({ src }: Pick<ImgHTMLAttributes<HTMLImageElement>, 'src'>) {
	return <img width={18} height={18} src={src} className={styles.avatar} />
}

function UserName({ name }: { name: string }) {
	return <span className={styles.name}>{name}</span>
}

export default function MentionUser({ data, ref, className, ...props }: MentionUserProps) {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.2 }}
			tabIndex={0}
			ref={ref}
			className={clsx(styles.root, className)}
			{...props}
		>
			{data.avatar && <UserAvatar src={data.avatar} />}
			<UserName name={data.screenName} />
		</motion.div>
	)
}
